<agpr-master-layout [id]="'visibilityIntelligence'">
    <ng-template let-item agprTemplate="navigation">
        <agpr-left-sidebar></agpr-left-sidebar>
    </ng-template>
</agpr-master-layout>
